import { render, staticRenderFns } from "./UserCashRegisterSetupForm.vue?vue&type=template&id=74f3d3f6&scoped=true&"
import script from "./UserCashRegisterSetupForm.vue?vue&type=script&lang=js&"
export * from "./UserCashRegisterSetupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f3d3f6",
  null
  
)

export default component.exports